import React from "react";
import PropTypes from "prop-types";

class ResourcesAccordion extends React.Component {
    render() {
        const { children, isResourcesAccordionOpen } = this.props;
        return (
            <section id="resources" className={`${isResourcesAccordionOpen ? "accordion__open" : ""} `}>
                {children}
            </section>
        );
    }
}

export default ResourcesAccordion;



// WEBPACK FOOTER //
// ./src/components/ResourcesAccordion.js